// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headline-lead{font-size:13px;color:var(--color-grey-1);margin:12px 0;line-height:1.77}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
